
<h3  style="font-size: 34px; line-height: 42px">{{step.text}}</h3>

<div *ngFor="let ingredient of step.ingredients">
  <app-recipe-ingredient [ingredient]="ingredient" [scale]="scale"></app-recipe-ingredient>
</div>